module.exports = ".grid_th_actions {\n  width: 170px;\n}\n.save-button {\n  padding-right: 7px;\n}\nui-text {\n  width: 220px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/styles/environment_grid.less
// module id = 1502
// module chunks = 4